import { LazyLoadEvent } from 'primeng/api';
import { ConsultaPaginada, MensagemService, ProgressoService, Restricao, Restricoes } from 'maestro-ng';
import { BaseService } from './base-service.service';

export class ServiceDataSourceScroller<E, I> {
  public entidades: E[];
  public lastLoadEvent: LazyLoadEvent;
  public restricoes: Restricoes;

  constructor(
    private service: BaseService<E, I>,
    private messageService: MensagemService,
    private progressService: ProgressoService,
    public rows = 10,
    public initialized = true
  ) {}

  public onLazyLoad(event: LazyLoadEvent): void {
    if (this.initialized) {
      if (event.first === 0) {
        this.entidades = Array.from({ length: this.rows * 2 });
      }

      if (
        this.lastLoadEvent !== undefined &&
        (event.sortField === undefined || event.sortOrder !== undefined || event.multiSortMeta !== undefined)
      ) {
        event.sortField = this.lastLoadEvent.sortField;
        event.sortOrder = this.lastLoadEvent.sortOrder;
        event.multiSortMeta = this.lastLoadEvent.multiSortMeta;
      }

      let restricoes: Array<Restricao<any>>;

      if (this.restricoes !== undefined) {
        restricoes = this.restricoes.getAtivas();
      }

      this.progressService.modeless();
      this.service.service
        .recuperarPaginado(this.newConsultaPaginada(event, restricoes))
        .then((result) => {
          this.setEntities(result.entidades);
          this.lastLoadEvent = event;
          this.progressService.fechar();
        })
        .catch((response) => {
          this.messageService.addErro('Erro ao carregar os dados no servidor', response.error);
          this.progressService.fechar();
        });
    } else {
      this.entidades = undefined;
      this.lastLoadEvent = undefined;
    }
  }

  protected setEntities(entidades: E[]): void {
    const preloaded = this.entidades.filter((entity) => entity !== undefined);

    if (entidades.length === 0) {
      this.entidades = preloaded;
    } else if (entidades.length < this.rows) {
      this.entidades = preloaded.concat(entidades);
    } else {
      this.entidades = preloaded.concat(entidades).concat(Array.from({ length: this.rows * 2 }));
    }
  }

  private initialize(): void {
    this.initialized = true;
  }

  public isValid(): boolean {
    return true;
  }

  public load(): void {
    if (!this.isValid()) {
      return;
    }
    this.initialize();
    this.onLazyLoad({ first: 0, rows: this.rows });
  }

  public clearRestrictions(): void {
    this.restricoes.limpar();
    this.load();
  }

  public onEnterSearch(event: any): void {
    if (event.keyCode === 13) {
      this.load();
    }
  }

  private newConsultaPaginada(event: LazyLoadEvent, restricoes: Array<Restricao<any>>): ConsultaPaginada {
    const consultaPaginada: any = {
      inicio: event.first,
      limite: event.rows,
      ordenacoes: [],
      restricoes: [],
      contabilizar: false,
    };

    if (restricoes && restricoes.length > 0) {
      consultaPaginada.restricoes = restricoes;
    }

    if (event.multiSortMeta) {
      event.multiSortMeta.forEach((s) => {
        consultaPaginada.ordenacoes.push({
          atributo: s.field,
          ordem: s.order === -1 ? 'DESC' : 'ASC',
        });
      });
    } else if (event.sortField) {
      consultaPaginada.ordenacoes.push({
        atributo: event.sortField,
        ordem: event.sortOrder === -1 ? 'DESC' : 'ASC',
      });
    }

    return consultaPaginada;
  }
}
